import React, {
  Fragment,
  useEffect,
  useState,
  useCallback,
  useRef,
} from "react";
import Calendar from "react-calendar";
import moment from "moment";
import { MdRefresh } from "react-icons/md";
import { TbEdit } from "react-icons/tb";
import { FaCircleArrowDown, FaCircleArrowUp } from "react-icons/fa6";
import { globalFileServer, globalFileIcon } from "../../../../axiosInstance";
import { GetProductsToOrder } from "../../../server/ProductToOrder";
import { orderGet } from "../../../server/Order";
import { updateStatus, updateOrder } from "../../../server/ActiveOrder";
import { setPreload } from "../../../server/CartsOpen";
import { useDispatch, useSelector } from "react-redux";
import PopUp from "../../containers/PopUp";

const AllOrders = () => {
  const dispatch = useDispatch();
  const stationId = useSelector((state) => state.user.stationId);
  const getOrderSums = (order) => {
    const productsSum = order.totalSum || 0;
    const delivery = order.deliveryPrice || 0;
    const coupon = order.couponDiscount || 0;

    const beforeCoupon = productsSum + delivery;
    const afterCoupon = beforeCoupon - coupon;

    return { beforeCoupon, afterCoupon };
  };

  const [date, setDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [items, setItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [search, setSearch] = useState("");
  const [showToCalendar, setShowToCalendar] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [lastRefresh, setLastRefresh] = useState(null);

  const [activeOrder, setActiveOrder] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);
  const [dataElement, setDataElement] = useState({});
  const [editingOrderId, setEditingOrderId] = useState(null);
  const [selectedValues, setSelectedValues] = useState({});

  const [filterStatus, setFilterStatus] = useState("");
  const [filterLateOrders, setFilterLateOrders] = useState(false);
  const [filterPaymentStatus, setFilterPaymentStatus] = useState("");

  const applyFilters = useCallback(() => {
    let filtered = [...items];

    if (search.trim()) {
      const lower = search.toLowerCase();
      filtered = filtered.filter((x) =>
        (x.name || "").toLowerCase().includes(lower),
      );
    }

    // if (filterStatus)
    //   filtered = filtered.filter((x) => x.StatusId === parseInt(filterStatus));

    if (filterPaymentStatus)
      filtered = filtered.filter(
        (x) => x.PaymentStatus === filterPaymentStatus,
      );

    if (filterLateOrders)
      filtered = filtered.filter((x) => x.dateTimeStatus === 3);

    setFilteredItems(filtered);
  }, [items, search, filterPaymentStatus, filterLateOrders]);

  useEffect(() => {
    applyFilters();
  }, [applyFilters]);

  const getItems = useCallback(
    (dateFrom, dateTo) => {
      let fromArr = dateFrom.split("/");
      let toArr = dateTo.split("/");
      const fromIso = fromArr[2] + "-" + fromArr[1] + "-" + fromArr[0];
      const toIso = toArr[2] + "-" + toArr[1] + "-" + toArr[0];

      let val = {
        from: fromIso,
        to: toIso,
        stationId: stationId,
      };
      dispatch(setPreload(true));
      orderGet(val)
        .then((x) => {
          console.log("RAW ORDERS FROM SERVER:", x.data.orders);

          const orders = Array.isArray(x.data.orders) ? x.data.orders : [];

          setItems(orders);
          setLastRefresh(new Date().toLocaleString("he-IL"));
        })
        .catch((err) => {
          console.log("error fetching orders:", err);
        })
        .finally(() => dispatch(setPreload(false)));
    },
    [dispatch, stationId],
  );

  const fetchOrders = useCallback(() => {
    const fromDate = date.toLocaleDateString("ru-RU").split(".").join("/");
    const toDateStr = toDate.toLocaleDateString("he-IL").split("/").join("/");
    getItems(fromDate, toDateStr);
    setTimeout(() => window.scrollTo(0, 0), 100);
  }, [date, toDate, getItems]);

  const fetchOrdersRef = useRef(fetchOrders);
  fetchOrdersRef.current = fetchOrders;

  useEffect(() => {
    fetchOrdersRef.current();
  }, [stationId]);

  const setSearchFun = (e) => {
    setSearch(e.target.value);
  };

  const clearSearch = () => {
    setSearch("");
  };

  const calendarChange = (selectedDate, action) => {
    if (action === "from") {
      setDate(selectedDate);
      setShowCalendar(false);
    } else {
      setToDate(selectedDate);
      setShowToCalendar(false);
    }
  };

  const selectDate = (action) => {
    if (action === "from") {
      setShowCalendar(!showCalendar);
      setShowToCalendar(false);
    } else {
      setShowToCalendar(!showToCalendar);
      setShowCalendar(false);
    }
  };

  const applyDateFilter = () => {
    fetchOrders();
  };

  const showInfo = (element) => {
    setOpenInfo(true);
    setDataElement(element);
  };

  // const setActiveOrderFun = (id) => {
  //   console.log("1setActiveOrderFun id:", id);
  //   if (activeOrder !== id) {
  //         console.log("2setActiveOrderFun id:", id);
  //     let findInd = items.findIndex((x) => x.id === id);
  //     if (findInd !== -1 && !items[findInd].orderItems) {
  //           console.log("3setActiveOrderFun id:", id);
  //       GetProductsToOrder(id)
  //         .then((x) => {
  //               console.log("4setActiveOrderFun id:", id);
  //           const itemsEdit = [...items];
  //           itemsEdit[findInd].orderItems = x.data;
  //           setItems(itemsEdit);
  //           setActiveOrder(id);
  //         })
  //         .catch(() => console.log("error"));
  //     } else {
  //       setActiveOrder(id);
  //     }
  //   } else {
  //     setActiveOrder(false);
  //   }
  // };
  const setActiveOrderFun = (id) => {
    if (activeOrder !== id) {
      const findInd = items.findIndex((x) => x.id === id);
      if (findInd !== -1 && !items[findInd].orderItems) {
        console.log(
          "Fetching products for order id:",
          id,
          "stationId:",
          stationId,
        );
        GetProductsToOrder(id, stationId)
          .then((response) => {
            const productsArray = Array.isArray(response.data)
              ? response.data
              : response.data.orderItems || [];

            const itemsEdit = [...items];
            const order = itemsEdit[findInd];

            // ממפה את המוצרים
            order.orderItems = productsArray.map((item) => ({
              name: item.product?.name || "מוצר לא נמצא",
              quantity: item.quantity,
              totalPrice: item.totalPrice || item.price * item.quantity,
              Price: item.price,
              productId: item.product.gtin,
              Id: item.productId,
              product: item.product,
              Comment: item.Comment || "",
            }));

            // מוסיף מוצר משלוח כאילו זה מוצר רגיל
            if (order.deliveryPrice) {
              order.orderItems.push({
                name: "משלוח",
                totalPrice: order.deliveryPrice,
                Price: order.deliveryPrice,
                Id: `delivery-${id}`,
                product: null,
                Comment: "",
              });
            }

            setItems(itemsEdit);
            setActiveOrder(id);
          })
          .catch(() => {});
      } else {
        setActiveOrder(id);
      }
    } else {
      setActiveOrder(false);
    }
  };
  const updateOrderStatus = async (orderId, newStatus) => {
    try {
      await updateStatus(orderId, newStatus);
      fetchOrders();
      setEditingOrderId(null);
    } catch (error) {
      console.error("Error updating order status:", error);
    }
  };
  const getStatusText = (status) => {
    if (!status) return "";

    if (status.includes("created")) {
      return "ממתין לליקוט";
    }
  };
  const moveOrder = async (id, direction) => {
    const orderIndex = filteredItems.findIndex((order) => order.id === id);
    if (orderIndex === -1) return;

    const newFilteredList = [...filteredItems];

    if (direction === "up" && orderIndex > 0) {
      [newFilteredList[orderIndex], newFilteredList[orderIndex - 1]] = [
        newFilteredList[orderIndex - 1],
        newFilteredList[orderIndex],
      ];

      try {
        await updateOrder(newFilteredList[orderIndex - 1].id, orderIndex);
        await updateOrder(newFilteredList[orderIndex].id, orderIndex - 1);
        setFilteredItems(newFilteredList);

        const newItems = [...items];
        const origIndex1 = newItems.findIndex(
          (o) => o.id === newFilteredList[orderIndex - 1].id,
        );
        const origIndex2 = newItems.findIndex(
          (o) => o.id === newFilteredList[orderIndex].id,
        );
        if (origIndex1 !== -1 && origIndex2 !== -1) {
          [newItems[origIndex1], newItems[origIndex2]] = [
            newItems[origIndex2],
            newItems[origIndex1],
          ];
          setItems(newItems);
        }
      } catch (error) {
        console.error("Error moving order:", error);
      }
    } else if (direction === "down" && orderIndex < filteredItems.length - 1) {
      [newFilteredList[orderIndex], newFilteredList[orderIndex + 1]] = [
        newFilteredList[orderIndex + 1],
        newFilteredList[orderIndex],
      ];

      try {
        await updateOrder(newFilteredList[orderIndex + 1].id, orderIndex + 1);
        await updateOrder(newFilteredList[orderIndex].id, orderIndex + 2);
        setFilteredItems(newFilteredList);

        const newItems = [...items];
        const origIndex1 = newItems.findIndex(
          (o) => o.id === newFilteredList[orderIndex + 1].id,
        );
        const origIndex2 = newItems.findIndex(
          (o) => o.id === newFilteredList[orderIndex].id,
        );
        if (origIndex1 !== -1 && origIndex2 !== -1) {
          [newItems[origIndex1], newItems[origIndex2]] = [
            newItems[origIndex2],
            newItems[origIndex1],
          ];
          setItems(newItems);
        }
      } catch (error) {
        console.error("Error moving order:", error);
      }
    }
  };

  const clearFilters = () => {
    setSearch("");
    setFilterStatus("");
    setFilterLateOrders(false);
    setFilterPaymentStatus("");
  };

  const uniqueStatuses = [
    ...new Map(
      items.map((item) => [
        item.StatusId,
        { id: item.StatusId, label: item.StatusName },
      ]),
    ).values(),
  ];

  const uniquePaymentStatuses = [
    ...new Set(items.map((item) => item.PaymentStatus).filter(Boolean)),
  ];

  return (
    <div className="all-orders">
      <h1 className="title-role">כל ההזמנות</h1>

      <div className="orders-header">
        <div className="header-content">
          <button onClick={fetchOrders} title="רענן">
            <MdRefresh />
          </button>
          {lastRefresh && (
            <span>
              שעת ריענון: {lastRefresh} | כמות הזמנות: {filteredItems.length}{" "}
              מתוך {items.length}
            </span>
          )}
        </div>
      </div>

      <div className="filters-container">
        <div className="filter-row">
          <div className="open-calendar">
            <button className="toggle" onClick={() => selectDate("from")}>
              <img
                loading="lazy"
                src={globalFileIcon + "calendar.svg"}
                alt=""
              />
              <span>
                מתאריך: {date.toLocaleDateString("he-IL").split(".").join("/")}
              </span>
            </button>
            <Calendar
              onChange={(date) => calendarChange(date, "from")}
              value={date}
              calendarType="Hebrew"
              locale="he-IL"
              className={showCalendar ? "active" : null}
            />
          </div>
          <div className="open-calendar">
            <button className="toggle" onClick={() => selectDate("to")}>
              <img
                loading="lazy"
                src={globalFileIcon + "calendar.svg"}
                alt=""
              />
              <span>
                עד תאריך:{" "}
                {toDate.toLocaleDateString("he-IL").split(".").join("/")}
              </span>
            </button>
            <Calendar
              onChange={(date) => calendarChange(date, "to")}
              value={toDate}
              calendarType="Hebrew"
              locale="he-IL"
              className={showToCalendar ? "active" : null}
            />
          </div>

          <button className="apply-date-btn" onClick={applyDateFilter}>
            החל תאריכים
          </button>

          <div className="search">
            <input
              onChange={setSearchFun}
              value={search}
              type="text"
              placeholder="שם לקוח..."
            />
            {search ? (
              <img
                loading="lazy"
                className="close"
                onClick={clearSearch}
                src={globalFileServer + "iconcss/close.svg"}
                alt=""
              />
            ) : (
              <img
                loading="lazy"
                src={globalFileServer + "iconcss/search.svg"}
                alt=""
              />
            )}
          </div>
        </div>

        <div className="filter-row">
          <div className="filter-select">
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
            >
              <option value="">כל סטטוסי הליקוט</option>
              {uniqueStatuses.map((status) => (
                <option key={status.id} value={status.id}>
                  {status.label}
                </option>
              ))}
            </select>
          </div>

          <div className="filter-select">
            <select
              value={filterPaymentStatus}
              onChange={(e) => setFilterPaymentStatus(e.target.value)}
            >
              <option value="">כל סטטוסי התשלום</option>
              {uniquePaymentStatuses.map((status, index) => (
                <option key={index} value={status}>
                  {status}
                </option>
              ))}
            </select>
          </div>

          <div className="filter-checkbox">
            <label>
              <input
                type="checkbox"
                checked={filterLateOrders}
                onChange={(e) => setFilterLateOrders(e.target.checked)}
              />
              <span>הזמנות באיחור בלבד</span>
            </label>
          </div>

          <button className="clear-filters-btn" onClick={clearFilters}>
            נקה פילטרים
          </button>
        </div>
      </div>

      {!filteredItems.length ? (
        <h1 className="no-products">לא נמצאו הזמנות התואמות את הפילטרים</h1>
      ) : (
        <table>
          <tbody>
            <tr>
              <th>מיון</th>
              <th></th>
              <th>#</th>
              <th>שם לקוח</th>
              <th>זמן ותאריך</th>
              {/* <th>מס מוצרים</th> */}
              <th>סכום הזמנה</th>
              <th>סכום לוקט</th>
              <th>פרטי לקוח</th>
              <th>סטטוס ליקוט</th>
              <th>סטטוס חיוב</th>
            </tr>
            {console.log("filteredItems", filteredItems)}
            {filteredItems.map((element, index) => {
              const canMoveUp = index > 0;
              const canMoveDown = index < filteredItems.length - 1;

              return (
                <Fragment key={index}>
                  <tr
                    className={
                      activeOrder === element.id ? "item active" : "item"
                    }
                  >
                    <td>
                      <div className="move-buttons">
                        <FaCircleArrowUp
                          className={`icon ${!canMoveUp ? "disabled" : ""}`}
                          onClick={() =>
                            canMoveUp && moveOrder(element.id, "up")
                          }
                        />
                        <FaCircleArrowDown
                          className={`icon ${!canMoveDown ? "disabled" : ""}`}
                          onClick={() =>
                            canMoveDown && moveOrder(element.id, "down")
                          }
                        />
                      </div>
                    </td>
                    <td>
                      <img
                        loading="lazy"
                        src={globalFileIcon + "down.svg"}
                        alt=""
                        onClick={() => setActiveOrderFun(element.id)}
                        className="expand-icon"
                      />
                    </td>
                    <td>
                      <p>{element.id}</p>
                    </td>
                    <td>
                      <p>
                        {element.name ? element.name : element.CustomerName}
                      </p>
                    </td>
                    <td>
                      <p>{moment(element.created).format("DD/MM/YY HH:mm")}</p>
                    </td>
                    {/* <td>
                      <p>{element.orderItems?.length}</p>
                    </td> */}
                    <td>
                      {element.couponDiscount ? (
                        <div className="price-details">
                          <p className="price original-price">
                            ₪{getOrderSums(element).beforeCoupon.toFixed(2)}
                          </p>
                          <p className="price ">
                            ₪{getOrderSums(element).afterCoupon.toFixed(2)}
                          </p>
                        </div>
                      ) : (
                        <p className="price">
                          ₪
                          {(
                            element.totalPrice + (element.deliveryPrice || 0)
                          ).toFixed(2)}
                        </p>
                      )}
                    </td>
                    <td>
                      <p className="price">{element.Payment} ₪</p>
                    </td>
                    <td>
                      <img
                        loading="lazy"
                        src={globalFileIcon + "info.svg"}
                        alt=""
                        onClick={() => showInfo(element)}
                        className="info-icon"
                      />
                    </td>
                    <td>
                      {editingOrderId === element.id ? (
                        <select
                          value={selectedValues[element.id] || ""}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setSelectedValues((prev) => ({
                              ...prev,
                              [element.id]: newValue,
                            }));
                            updateOrderStatus(element.id, parseInt(newValue));
                          }}
                          onBlur={() => setEditingOrderId(null)}
                          autoFocus
                        >
                          {uniqueStatuses.map((status) => (
                            <option key={status.id} value={status.id}>
                              {status.label}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <div className="status-cell">
                          {/* <p>{element.StatusName}</p> */}
                          <p>{getStatusText(element.tenantStatus)}</p>

                          <TbEdit
                            className="icon edit-icon"
                            onClick={() => {
                              setEditingOrderId(element.id);
                              setSelectedValues((prev) => ({
                                ...prev,
                                [element.id]: element.StatusId,
                              }));
                            }}
                          />
                        </div>
                      )}
                    </td>
                    <td>
                      <p>{element.PaymentStatus}</p>
                    </td>
                  </tr>
                  {activeOrder === element.id &&
                  element.orderItems &&
                  element.orderItems.length ? (
                    <>
                      <tr className="product-list">
                        <td></td>
                        <td></td>
                        <td>
                          <p>שם מוצר</p>
                        </td>
                        <td>
                          <p>ברקוד</p>
                        </td>
                        <td>
                          <p>כמות</p>
                        </td>
                        <td>
                          <p>מחיר</p>
                        </td>
                        <td colSpan="5">
                          <p>הערות</p>
                        </td>
                      </tr>
                      {element.orderItems.map((el) => {
                        return (
                          <tr key={el.Id} className="product">
                            <td></td>
                            <td></td>
                            <td>
                              <p>{el.name}</p>
                            </td>
                            <td>
                              <p>{el.productId}</p>
                            </td>
                            <td>
                              <p>{el.quantity}</p>
                            </td>
                            <td>
                              <p className="price">{el.totalPrice} ₪</p>
                            </td>
                            <td colSpan="5">
                              <p>{el.Comment}</p>
                            </td>
                          </tr>
                        );
                      })}
                      {element.couponDiscount && (
                        <tr className="product coupon-row">
                          <td></td>
                          <td></td>
                          <td>הנחת קופון</td>
                          <td></td>
                          <td></td>
                          <td className="price">
                            -₪{element.couponDiscount.toFixed(2)}
                          </td>
                          <td></td>
                          <td colSpan="3"></td>
                        </tr>
                      )}
                    </>
                  ) : null}
                </Fragment>
              );
            })}
          </tbody>
        </table>
      )}

      {openInfo ? (
        <PopUp width="600px" close={() => setOpenInfo(false)}>
          <div className="comment-popup">
            <p>
              שם:{" "}
              {dataElement.name ? dataElement.name : dataElement.CustomerName}
            </p>
            <p>
              מייל: {dataElement.email ? dataElement.email : dataElement.Email}
            </p>
            <p>
              טלפון: {dataElement.phone ? dataElement.phone : dataElement.Phone}
            </p>
            <p>
              כתובת משלוח:{" "}
              {dataElement.address
                ? dataElement.address
                : dataElement.FullAddress}
            </p>
            {dataElement.Comment ? <p>הערה: {dataElement.Comment}</p> : null}
          </div>
        </PopUp>
      ) : null}
    </div>
  );
};

export default AllOrders;
